;(async () => {
  if(customElements.get('v3-product-card')) {
    return;
  }

  const storeModuleURL = window.__GLOBAL__.assets.store;
  const module = await import(storeModuleURL);
  const store = module.default;

  const IMAGE_SIZES = [48, 85, 90, 112, 256, 320, 360, 480, 640, 750, 828, 1080, 1200, 1920, 2048, 3840];

  class V3ProductCards extends HTMLElement {
    constructor() {
      super();
      this.loading = this.dataset.loading;
      this.hideSwatches = this.dataset.hideSwatches;
      this.io = new IntersectionObserver(this.observerCallback.bind(this), {
        rootMargin: "900px",
        threshold: 0.01
      });
    }

    connectedCallback() {
      this.eventsController = new AbortController();

      this.io.observe(this);
      this.mouseLeaveTimeout;
    }

    observerCallback(entries) {
      entries.forEach((entry) => {
        if(entry.isIntersecting == true) {
          this.getCardUI();
        }
      })
    }

    async getCardUI() {
      const productUrl = new URL(this.dataset.url);
      productUrl.searchParams.append('view', 'card');

      const req = await fetch(productUrl, {
        method: "get"
      })

      const res = await req.text();

      this.io.disconnect();

      this.innerHTML = res;

      this.initCard();
    }

    initCard() {
      let familyDataObject = this.querySelector('[data-product-family]');

      this.classList.remove('skeleton-item');

      this.productObject = JSON.parse(this.querySelector('[data-product-json]').textContent);
      this.quickAddForm = this.querySelector('[data-quick-add-form]');
      this.variantButtonsContainer = this.querySelector('[data-variant-buttons-container]')
      this.variantSelect = this.querySelector('[data-variant-select]');
      this.productBadge = this.querySelector('[data-product-badge]');
      this.regularPrice = this.querySelector('[data-regular-price]');
      this.comparePrice = this.querySelector('[data-compare-price]');
      this.discountMessage = this.querySelector('[data-discount-message]');
      this.productUrl = this.querySelectorAll('[data-product-url]');
      this.bisFormTrigger = this.querySelector('[data-bis-form-trigger]');
      this.mainImage = this.querySelector('[data-main-image]');
      this.hoverImge = this.querySelector('[data-hover-image]');

      if(familyDataObject) {
        this.productFamilyObject = JSON.parse(familyDataObject.textContent);
      }

      if(this.hideSwatches) {
        this.querySelector('.product-card__colors').remove();
      }

      this.initCardEvents();

      this.updateProductUrl(this.productObject);
      this.updateProductPrice(this.productObject);
      this.updateProductQuickAdd(this.productObject);
      this.updateProductImages(this.productObject);
    }

    initCardEvents() {
      this.hoveredCheckbox = null;
      if(!this.hideSwatches) {
        this.querySelector('.product-card__info').addEventListener('change', this.onVariantChange.bind(this), {
          signal: this.eventsController.signal
        })
      }
      this.bisFormTrigger.addEventListener('click', this.onBisTriggerClick.bind(this), {
        signal: this.eventsController.signal
      })
      this.bisFormTrigger.addEventListener('mouseenter', this.onBisButtonMouseEnter.bind(this), {
        signal: this.eventsController.signal
      });
      this.bisFormTrigger.addEventListener('mouseleave', this.onBisButtonMouseLeave.bind(this), {
        signal: this.eventsController.signal
      });
      this.querySelector('form').addEventListener('change', this.onQuickAddSelectChange.bind(this), {
        signal: this.eventsController.signal
      })
      this.querySelector('form').addEventListener('mouseover', this.onOptionMouseEnter.bind(this), {
        signal: this.eventsController.signal
      });
      this.querySelector('form').addEventListener('mouseout', this.onOptionMouseLeave.bind(this), {
        signal: this.eventsController.signal
      })
    }

    onVariantChange(evt) {
      const newProduct = this.productFamilyObject[evt.target.value];

      this.updateProductBadge(newProduct);
      this.updateProductImages(newProduct);
      this.updateProductPrice(newProduct);
      this.updateProductUrl(newProduct);
      this.updateProductQuickAdd(newProduct);
    }

    updateProductBadge(productObject) {
      const newBadge = productObject.tags.find(badge => badge.indexOf('collection_bd:') > -1);
      if(newBadge) {
        this.productBadge.innerText = newBadge.replace('collection_bd:', '');
        this.productBadge.removeAttribute('style');
      } else {
        this.productBadge.style.display = "none";
      }
    }

    updateProductImages(productObject){
      console.log('initializing images');
      let mainImageIndex = 0;
      let hoverImageIndex = 1;

      if(this.loading == 'eager') {
        this.mainImage.loading = 'eager';
        this.mainImage.fetchPriority = 'high';
      }

      if(this.dataset.gendered) {
        const genderLabel = `${this.dataset.gendered}_gendered_images`;
        mainImageIndex = productObject.metafields[genderLabel].main ? productObject.metafields[genderLabel].main : 0;
        hoverImageIndex = productObject.metafields[genderLabel].hover ? productObject.metafields[genderLabel].hover : 1;
      }

      if(!this.mainImage) return;
      this.mainImage.src = productObject.images[mainImageIndex].url;
      this.mainImage.alt = productObject.images[mainImageIndex].alt;
      this.mainImage.srcset = IMAGE_SIZES.map(size => `${productObject.images[mainImageIndex].url}&width=${size} ${size}w`).join(', ');

      this.hoverImge.src = productObject.images[hoverImageIndex].url;
      this.hoverImge.alt = productObject.images[hoverImageIndex].alt;
      this.hoverImge.srcset = IMAGE_SIZES.map(size => `${productObject.images[hoverImageIndex].url}&width=${size} ${size}w`).join(', ');
    }

    updateProductPrice(productObject){
      this.regularPrice.innerText = Shopify.formatMoney(productObject.price, window._moneyFormat).replace(/[.,]00$/g, '');

      if(productObject.compare_at_price > productObject.price) {
        this.comparePrice.innerText = Shopify.formatMoney(productObject.compare_at_price, window._moneyFormat).replace(/[.,]00$/g, '');
        this.comparePrice.removeAttribute('style');
      } else {
        this.comparePrice.style.display = "none";
      }

      //Check for custom promotional messages
      if(sessionStorage.getItem('discountMessage') != null) {
        if(productObject.collections?.includes(sessionStorage.getItem('applicableCollection'))) {
          this.discountMessage.innerText = sessionStorage.getItem('discountMessage');
          this.discountMessage.removeAttribute('style');
        }
        return;
      }

      if(window.promoMessages.length > 0) {
        const promoObject = window.promoMessages.find((messageObject) => productObject.collections?.includes(messageObject.allowedCollection))

        if(promoObject) {
          this.discountMessage.innerText = promoObject.promoMessage;
          this.discountMessage.removeAttribute('style');
        }
        return;
      }

      if(productObject.compare_at_price > productObject.price) {
        const priceDif = productObject.compare_at_price - productObject.price;
        const discount = Math.round(priceDif * 100 / productObject.compare_at_price)

        this.discountMessage.innerText = `${discount}% OFF`;
        this.discountMessage.removeAttribute('style');
      } else {
        this.discountMessage.style.display = "none";
      }
    }

    updateProductUrl(productObject) {
      let newProductUrl = productObject.url;
      if(document.location.pathname.indexOf('/collections') > -1) {
        newProductUrl = productObject.url.replace('/products', `${document.location.pathname}/products`);
      }
      if(this.productUrl) {
        this.productUrl.forEach(url => {
          url.href = newProductUrl;
        })
      }
    }

    updateProductQuickAdd(productObject) {
      if(productObject.options_with_values.length == 2) {
        const buttons = [];
        const options = [`<option value=""></option>`];

        productObject.variants.forEach(variant => {
          buttons.push(`
          <li class="product-card__variant-option">
            <label for="product-option-${ productObject.id }-${ variant.options[1] }"
              ${variant.available ? '' : 'data-disabled'}
            >
              <input
                id="product-option-${ productObject.id }-${ variant.options[1] }"
                value="${variant.id}"
                type="checkbox"
                class="product-card__option-value"
                data-product-name="${ productObject.title }"
                data-variant-title="${ variant.title }"
                data-variant-id="${ variant.id }"
                tabindex="-1"
                ${variant.available ? '':'disabled'}
              >
              ${ variant.options[1] }
            </label>
          </li>
          `)
          options.push(`
            <option value="${ variant.id }" ${variant.available? '': 'disabled'}>${ variant.title }</option>
          `)
        })

        this.variantButtonsContainer.innerHTML = buttons.join('');
        this.variantSelect.innerHTML = options.join('');

        this.quickAddForm.removeAttribute('style');
      } else {
        this.quickAddForm.style.display = "none";
      }
    }

    onOptionMouseEnter(evt) {
      const checkbox = evt.target.closest('input[type="checkbox"]');
      if(!checkbox || !this.variantButtonsContainer.contains(checkbox)) return;

      clearTimeout(this.mouseLeaveTimeout);

      if(checkbox !== this.hoveredCheckbox) {
        this.hoveredCheckbox = checkbox;

        if(checkbox.disabled) {
          this.bisFormTrigger.setAttribute('data-product-name', checkbox.dataset.productName);
          this.bisFormTrigger.setAttribute('data-variant-title', checkbox.dataset.variantTitle);
          this.bisFormTrigger.setAttribute('data-variant-id', checkbox.dataset.variantId);
          this.bisFormTrigger.removeAttribute('hidden');
        } else {
          this.bisFormTrigger.setAttribute('hidden', true);
        }
      }
    }

    onOptionMouseLeave(evt) {
      const checkbox = evt.target.closest('input[type="checkbox"]');

      if(!checkbox || !this.variantButtonsContainer.contains(checkbox)) return;

      const related = evt.relatedTarget;

      if(!related || !checkbox.contains(related)) {
        this.hoveredCheckbox = null;
        this.mouseLeaveTimeout = setTimeout(() => {
          this.bisFormTrigger.setAttribute('hidden', true);
        },500)
      }
    }

    onBisTriggerClick(evt) {
      document.dispatchEvent(new CustomEvent('bisForm:open', {
        detail: {
          productTitle: this.bisFormTrigger.dataset.productTitle,
          variantTitle: this.bisFormTrigger.dataset.variantTitle,
          variantId: this.bisFormTrigger.dataset.variantId,
        }
      }))
    }

    onBisButtonMouseEnter(evt) {
      clearTimeout(this.mouseLeaveTimeout);
    }

    onBisButtonMouseLeave(evt) {
      this.bisFormTrigger.setAttribute('hidden', true);
    }

    onQuickAddSelectChange(evt) {
      evt.preventDefault();

      const id = evt.target.value;

      if(id) {
        store.dispatch('addItems', {
          [id]: 1,
        }, true)
        this.variantSelect.value = "";
      }
    }

    disconnectedCallback() {
      this.eventsController.abort();
    }
  }

  customElements.define('v3-product-card', V3ProductCards);
})()